
import React, { useEffect } from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { Container, Typography, Button, Paper, List, ListItem, ListItemText, Divider, Box } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

function SuccessPage({ clearCart }) {
  const location = useLocation();
  const { cart } = location.state || { cart: [] };

  useEffect(() => {
    if (clearCart) {
      clearCart();
    }
  }, [clearCart]);


  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 4, textAlign: 'center' }}>
        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60 }} />
        <Typography variant="h4" component="h1" gutterBottom sx={{ mt: 2 }}>
          Purchase Successful!
        </Typography>
        <Typography variant="body1" gutterBottom>
          Thank you for your purchase. Here are the details of your order:
        </Typography>

        <List sx={{ my: 3, textAlign: 'left' }}>
          {cart.map((item, index) => (
            <React.Fragment key={item.id}>
              <ListItem>
                <ListItemText 
                  primary={`Image ID: ${item.id}`}
                  secondary={`Race: ${item.raceName} - Price: $${item.price}`}
                />
              </ListItem>
              {index < cart.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
          You will receive an email confirmation shortly. You can download your purchased images from your account page.
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Button variant="contained" component={RouterLink} to="/dashboard">
            Go to Dashboard
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default SuccessPage;
